import { Navigate, Route, Routes } from "react-router-dom";

import { ColocaSkeleton } from "@/shared/components/feedback/ColocaSkeleton";

import { useWalletTopUpAccess } from "./hooks/useWalletTopUpAccess";
import WalletTopUpsPage from "./pages/WalletTopUpsPage";

// The registry's `enabled` flag only hides the menu entry, so the route closes itself too for staff off the
// allowlist. The backend refuses them regardless.
export const WalletTopUpsNavigation = () => {
  const { allowed, isLoading } = useWalletTopUpAccess();
  if (isLoading) return <ColocaSkeleton className="m-2 h-40 w-full max-w-[1400px] rounded-2xl" />;
  if (!allowed) return <Navigate to="/app/wallets" replace />;
  return (
    <Routes>
      <Route index element={<WalletTopUpsPage />} />
      <Route path="*" element={<Navigate to="/app/wallet-top-ups" replace />} />
    </Routes>
  );
};
